'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = require('preact');

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _PushItem = require('./PushItem');

var _PushItem2 = _interopRequireDefault(_PushItem);

var _PushComplimentary = require('./PushComplimentary');

var _PushComplimentary2 = _interopRequireDefault(_PushComplimentary);

var _PushRecommendations = require('./PushRecommendations');

var _PushRecommendations2 = _interopRequireDefault(_PushRecommendations);

var _functional = require('../../utils/functional');

var _PushAutomaticGift = require('./PushAutomaticGift');

var _PushAutomaticGift2 = _interopRequireDefault(_PushAutomaticGift);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-unused-vars
/* eslint-disable no-console */
/* eslint-disable-next-line no-unused-vars */
var PushCart = function (_Component) {
  (0, _inherits3.default)(PushCart, _Component);

  function PushCart(props) {
    (0, _classCallCheck3.default)(this, PushCart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PushCart.__proto__ || Object.getPrototypeOf(PushCart)).call(this, props));

    window.cart = cart;
    window.giftAdded = false;
    window.PushCart = {
      addItem: _this.addItem.bind(_this),
      addItems: _this.addItems.bind(_this)
    };

    _this.state = {
      itemBeingAdded: false,
      loading: false,
      items: [],
      subtotal: null,
      maxQuantity: 15,
      itemCount: 0,
      showUpsell: false,
      upsell: _this.props.upsell,
      complimentary: _this.props.complimentary,
      currencyData: JSON.parse((0, _functional.getElement)('[data-push-cart-currency-data]').textContent),
      currency: window.theme.currency,
      loadingRecommendations: false,
      automaticGift: new _PushAutomaticGift2.default()
    };

    _this.setupForms();

    _this.removeAllItems = _this.removeAllItems.bind(_this);
    _this.updateCart = _this.updateCart.bind(_this);
    _this.updateQuantityOfItem = _this.updateQuantityOfItem.bind(_this);

    _this.externalEls = {
      cartCounts: (0, _functional.getElements)('[data-cart-count]')
    };

    _this.refs = {
      topBar: null,
      footer: null,
      notificationBar: null,
      recommendations: null
    };
    cart.getState().then(function (data) {
      _this.processAutomaticGift();
      _this.updateCart(data);
    }).catch(function (err) {
      return console.error(err);
    });

    window.addEventListener('cart:removed', function (e) {
      cart.getState().then(function (data) {
        return _this.updateCart(data);
      }).catch(function (err) {
        return console.error(err);
      });
    }, false);
    return _this;
  }

  (0, _createClass3.default)(PushCart, [{
    key: 'setupForms',
    value: function setupForms() {
      var _this2 = this;

      document.body.addEventListener('submit', function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
          var form, formData, id, quantity, tiktokId, tiktokQuantity, tiktokContentName, tiktokPrice, tiktokValue, properties, keysToStrip, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value, strippedKey;

          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  form = e.target;

                  if (!form.matches('.js-AddToCart')) {
                    _context.next = 39;
                    break;
                  }

                  e.preventDefault();
                  e.stopPropagation();

                  _this2.setState({
                    loading: true
                  });

                  formData = new FormData(form);
                  id = Number(formData.get('id'));
                  quantity = Number(formData.get('quantity'));
                  tiktokId = formData.get('id').toString();
                  tiktokQuantity = Number(formData.get('quantity'));
                  tiktokContentName = formData.get('tiktok_content_name').toString();
                  tiktokPrice = Number(formData.get('tiktok_price')) || 0;
                  tiktokValue = Number(formData.get('tiktok_value')) * tiktokQuantity || 0;
                  properties = {};
                  keysToStrip = ['properties[_is_bundle]', 'properties[_complimentary]', 'properties[_complimentary_max]', 'properties[_automatic_gift]'];


                  if (window.theme.enableTiktokTracking === true) {
                    /* eslint-disable */
                    ttq.instance(tiktok_id).track('AddToCart', {
                      content_category: 'product',
                      content_type: 'product',
                      content_id: tiktokId,
                      content_name: tiktokContentName,
                      quantity: tiktokQuantity,
                      price: tiktokPrice,
                      value: tiktokValue,
                      currency: window.theme.currency
                    });
                    /* eslint-enable */
                  }

                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context.prev = 19;
                  for (_iterator = formData.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _ref2 = _step.value;
                    _ref3 = (0, _slicedToArray3.default)(_ref2, 2);
                    key = _ref3[0];
                    value = _ref3[1];

                    if (keysToStrip.includes(key)) {
                      strippedKey = key.replace(/(^properties\[|]$)/g, '');

                      properties[strippedKey] = value;
                    } else if (key.includes('properties[')) {
                      properties[key] = value;
                    }
                  }

                  _context.next = 27;
                  break;

                case 23:
                  _context.prev = 23;
                  _context.t0 = _context['catch'](19);
                  _didIteratorError = true;
                  _iteratorError = _context.t0;

                case 27:
                  _context.prev = 27;
                  _context.prev = 28;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 30:
                  _context.prev = 30;

                  if (!_didIteratorError) {
                    _context.next = 33;
                    break;
                  }

                  throw _iteratorError;

                case 33:
                  return _context.finish(30);

                case 34:
                  return _context.finish(27);

                case 35:
                  window.drawers.activeDrawerKey = 'cart';

                  _context.next = 38;
                  return _this2.addItem(id, {
                    quantity: quantity,
                    properties: properties
                  });

                case 38:

                  if ((form.matches('.prd-Product_Body') || form.matches('.prd-Item_Content')) && _this2.complimentaryInCartCount < _this2.state.complimentary.max && _this2.state.subtotal > _this2.state.complimentary.min_price) {
                    setTimeout(function () {
                      var complimentaryEl = (0, _functional.getElement)('[data-modal="complimentary"]');

                      if (complimentaryEl) {
                        complimentaryEl.classList.add('mod-Modal-active');
                      }
                    }, 1250);
                  }

                case 39:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2, [[19, 23, 27, 35], [28,, 30, 34]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), true);
    }
  }, {
    key: 'updateCart',
    value: function updateCart(data) {
      this.setState({
        loading: false,
        items: data.items,
        subtotal: data.total_price,
        itemCount: data.item_count
      });

      if (window.giftEnabled) {
        var quantity = 1;
        var properties = {};

        var addGift = this.shouldAddGift;

        if (addGift && !this.cartHasGift) {
          window.giftAdded = true;

          this.addItem(window.freeGiftId, {
            quantity: quantity,
            properties: properties
          });
        } else if (!addGift && this.cartHasGift) {
          var tempGift = this.state.items.find(function (x) {
            return x.id === window.freeGiftId;
          });
          if (tempGift) {
            window.giftAdded = false;
            this.removeItem(tempGift.key);
          }
        }
      }

      if (this.state.subtotal < this.state.complimentary.min_price && this.complimentaryInCartCount === this.state.complimentary.max) {
        var complimentaryGift = this.state.items.find(function (x) {
          return Object.keys(x.properties).includes('_complimentary');
        });
        if (complimentaryGift) {
          this.removeItem(complimentaryGift.key);
        }
      }

      this.processAutomaticGift();

      if (this.promotionEnabled && this.promotionQualifyingTotal !== 0) {
        var _quantity = 1;
        var _properties = {
          __giftWithPurchase: true
        };

        var addPromotionGift = this.shouldAddPromotionGift;

        if (this.cartHasPromotionGift) {
          var currentTotal = this.state.subtotal;
          var itemTotal = 0;
          this.state.items.forEach(function (item) {
            if (item.properties.__giftWithPurchase) return;
            itemTotal = itemTotal + item.final_price * item.quantity;
          });

          if (currentTotal > itemTotal) {
            this.state.subtotal = itemTotal;
          }
        }

        if (addPromotionGift && !this.cartHasPromotionGift && this.promotionGiftId != null && this.state.subtotal > this.promotionQualifyingTotal) {
          window.promotionGiftAdded = true;

          this.addItem(this.promotionGiftId, {
            quantity: _quantity,
            properties: _properties
          });
        } else if (!addPromotionGift && this.cartHasPromotionGift) {
          this.removePromoItem();
        }

        if (this.state.subtotal < this.promotionQualifyingTotal) {
          this.removePromoItem();
        }
      }

      if (this.state.itemBeingAdded !== null && this.state.itemBeingAdded !== false) {
        if (this.complimentaryInCartCount < this.state.complimentary.max && this.state.subtotal > this.state.complimentary.min_price) {
          setTimeout(function () {
            var complimentaryEl = (0, _functional.getElement)('[data-modal="complimentary"]');

            if (complimentaryEl) {
              (0, _functional.getElement)('[data-modal="complimentary"]').classList.add('mod-Modal-active');
            }
          }, 1250);
        }
      }

      this.setState({ itemBeingAdded: null });

      this.externalEls.cartCounts.forEach(function (el) {
        return el.innerText = data.item_count;
      });

      var event = new Event('cart:updated');
      // Dispatch the event.
      window.dispatchEvent(event);
    }
  }, {
    key: 'updateQuantityOfItem',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(quantity, item) {
        var data;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return cart.updateItem(item.key, { quantity: quantity });

              case 2:
                data = _context2.sent;
                return _context2.abrupt('return', this.updateCart(data));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateQuantityOfItem(_x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return updateQuantityOfItem;
    }()
  }, {
    key: 'addItems',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(items) {
        var data;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    items: items.map(function (item) {
                      return {
                        id: item.id,
                        quantity: item.quantity || 1
                      };
                    })
                  })
                });

              case 2:
                _context3.next = 4;
                return cart.getState();

              case 4:
                data = _context3.sent;
                return _context3.abrupt('return', this.updateCart(data));

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function addItems(_x4) {
        return _ref5.apply(this, arguments);
      }

      return addItems;
    }()
  }, {
    key: 'addItem',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(id, options) {
        var addedItem, productMetafieldData, data;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({
                  itemBeingAdded: id,
                  loading: true,
                  showUpsell: true
                });

                _context4.next = 3;
                return cart.addItem(id, options);

              case 3:
                addedItem = _context4.sent;
                _context4.next = 6;
                return cart.updateAttributes({ lastAddedHandle: addedItem.handle });

              case 6:
                _context4.next = 8;
                return (0, _functional.fetchProductMetafields)(addedItem.handle);

              case 8:
                productMetafieldData = _context4.sent;

                if (!productMetafieldData.upsell.product) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 12;
                return this.setState({
                  upsell: Object.assign({}, this.state.upsell, {
                    productHandle: productMetafieldData.upsell.product
                  })
                });

              case 12:
                _context4.next = 16;
                break;

              case 14:
                _context4.next = 16;
                return this.setState({
                  upsell: Object.assign({}, this.state.upsell, {
                    productHandle: this.props.upsell.fallbackProductHandle
                  })
                });

              case 16:
                _context4.next = 18;
                return cart.getState();

              case 18:
                data = _context4.sent;
                return _context4.abrupt('return', this.updateCart(data));

              case 20:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addItem(_x5, _x6) {
        return _ref6.apply(this, arguments);
      }

      return addItem;
    }()
  }, {
    key: 'removeItem',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(key) {
        var data;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return cart.removeItem(key);

              case 2:
                data = _context5.sent;


                this.setState({
                  showUpsell: false
                });

                return _context5.abrupt('return', this.updateCart(data));

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function removeItem(_x7) {
        return _ref7.apply(this, arguments);
      }

      return removeItem;
    }()
  }, {
    key: 'removeAllItems',
    value: function () {
      var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(e) {
        var data;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                e.preventDefault();

                this.setState({
                  loading: true,
                  showUpsell: false
                });

                _context6.next = 4;
                return cart.clearItems();

              case 4:
                data = _context6.sent;
                return _context6.abrupt('return', this.updateCart(data));

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function removeAllItems(_x8) {
        return _ref8.apply(this, arguments);
      }

      return removeAllItems;
    }()
  }, {
    key: 'removePromoItem',
    value: function () {
      var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
        var tempPromotionGift, promoKey, data;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                tempPromotionGift = this.state.items.find(function (x) {
                  return x.properties.__giftWithPurchase;
                });

                if (!tempPromotionGift) {
                  _context7.next = 8;
                  break;
                }

                window.promotionGiftAdded = false;
                promoKey = tempPromotionGift.key;
                _context7.next = 6;
                return cart.removeItem(promoKey);

              case 6:
                data = _context7.sent;
                return _context7.abrupt('return', this.updateCart(data));

              case 8:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function removePromoItem() {
        return _ref9.apply(this, arguments);
      }

      return removePromoItem;
    }()
  }, {
    key: 'processAutomaticGift',
    value: function () {
      var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(state) {
        var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref11$silent = _ref11.silent,
            silent = _ref11$silent === undefined ? true : _ref11$silent,
            _ref11$noRefresh = _ref11.noRefresh,
            noRefresh = _ref11$noRefresh === undefined ? false : _ref11$noRefresh;

        var _ref12, productsToAdd, productsToRemove, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, product, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _product;

        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.state.automaticGift.isEligible()) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt('return', state);

              case 2:
                _context8.next = 4;
                return this.state.automaticGift.getProductsToAddRemove();

              case 4:
                _ref12 = _context8.sent;
                productsToAdd = _ref12.productsToAdd;
                productsToRemove = _ref12.productsToRemove;

                if (!(productsToAdd.length === 0 && productsToRemove.length === 0)) {
                  _context8.next = 11;
                  break;
                }

                if (noRefresh) {
                  _context8.next = 10;
                  break;
                }

                return _context8.abrupt('return', state);

              case 10:
                return _context8.abrupt('return', null);

              case 11:

                // This opens the cart drawer
                window.drawers.activeDrawerKey = 'cart';

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context8.prev = 15;
                _iterator2 = productsToRemove[Symbol.iterator]();

              case 17:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context8.next = 25;
                  break;
                }

                product = _step2.value;
                _context8.next = 21;
                return this.removeItem(product.key);

              case 21:
                state = _context8.sent;

              case 22:
                _iteratorNormalCompletion2 = true;
                _context8.next = 17;
                break;

              case 25:
                _context8.next = 31;
                break;

              case 27:
                _context8.prev = 27;
                _context8.t0 = _context8['catch'](15);
                _didIteratorError2 = true;
                _iteratorError2 = _context8.t0;

              case 31:
                _context8.prev = 31;
                _context8.prev = 32;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 34:
                _context8.prev = 34;

                if (!_didIteratorError2) {
                  _context8.next = 37;
                  break;
                }

                throw _iteratorError2;

              case 37:
                return _context8.finish(34);

              case 38:
                return _context8.finish(31);

              case 39:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context8.prev = 42;
                _iterator3 = productsToAdd[Symbol.iterator]();

              case 44:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context8.next = 52;
                  break;
                }

                _product = _step3.value;
                _context8.next = 48;
                return this.addItem(_product.id, {
                  quantity: _product.quantity,
                  properties: _product.properties
                });

              case 48:
                state = _context8.sent;

              case 49:
                _iteratorNormalCompletion3 = true;
                _context8.next = 44;
                break;

              case 52:
                _context8.next = 58;
                break;

              case 54:
                _context8.prev = 54;
                _context8.t1 = _context8['catch'](42);
                _didIteratorError3 = true;
                _iteratorError3 = _context8.t1;

              case 58:
                _context8.prev = 58;
                _context8.prev = 59;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 61:
                _context8.prev = 61;

                if (!_didIteratorError3) {
                  _context8.next = 64;
                  break;
                }

                throw _iteratorError3;

              case 64:
                return _context8.finish(61);

              case 65:
                return _context8.finish(58);

              case 66:
                return _context8.abrupt('return', state);

              case 67:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[15, 27, 31, 39], [32,, 34, 38], [42, 54, 58, 66], [59,, 61, 65]]);
      }));

      function processAutomaticGift(_x9) {
        return _ref10.apply(this, arguments);
      }

      return processAutomaticGift;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.items.length !== this.state.items.length) {
        // The recommendations will be fetched in the PushRecommendations component
        // when the mostRecentlyAddedItemProductId changes
      }
    }
  }, {
    key: 'render',
    value: function render(props, state, context) {
      var _this3 = this;

      var recommendationCount = window.theme && window.theme.pushcartRecommendationsCount ? window.theme.pushcartRecommendationsCount : 4;

      return (0, _preact.h)(
        'div',
        { className: 'crt-Push' + (state.loading ? ' crt-Push-loading' : '') },
        (0, _preact.h)('ig-shipping-progress-container', {
          'class': 'crt-Int_Notification',
          'aria-hidden': window.theme.currency !== 'GBP' && window.theme.enableIntelligems === true
        }),
        window.theme.enablePushCartRecommendations && (0, _preact.h)(_PushRecommendations2.default, {
          items: state.items,
          mostRecentlyAddedItemProductId: this.mostRecentlyAddedItemProductId,
          translations: props.translations,
          className: 'crt-Recommended-desktop',
          maxRecommendations: recommendationCount
        }),
        (0, _preact.h)(
          'div',
          { className: 'crt-PushInner' },
          (0, _preact.h)(
            'div',
            { className: 'crt-Push_Header' },
            (0, _preact.h)(
              'div',
              {
                className: 'crt-Push_TopBar',
                ref: function ref(el) {
                  return _this3.refs.topBar = el;
                }
              },
              (0, _preact.h)(
                'h4',
                { className: 'crt-Push_Title' },
                props.translations.title,
                ' (',
                state.itemCount,
                ')'
              ),
              (0, _preact.h)(
                'button',
                {
                  type: 'button',
                  className: 'crt-Push_Close',
                  'data-module-drawers-close': 'cart'
                },
                (0, _preact.h)(
                  'svg',
                  { viewBox: '0 0 21 21', xmlns: 'http://www.w3.org/2000/svg' },
                  (0, _preact.h)(
                    'g',
                    {
                      stroke: '#000',
                      fill: 'none',
                      'fill-rule': 'evenodd',
                      'stroke-linecap': 'square'
                    },
                    (0, _preact.h)('path', { d: 'M.5.5l9.513 9.513M10.5 10.5L.987 20.013' }),
                    (0, _preact.h)(
                      'g',
                      null,
                      (0, _preact.h)('path', { d: 'M20.5 20.5l-9.513-9.513M10.5 10.5L20.013.987' })
                    )
                  )
                )
              )
            ),
            (0, _preact.h)(
              'div',
              {
                className: 'crt-Push_Notification',
                ref: function ref(el) {
                  return _this3.refs.notificationBar = el;
                },
                'aria-hidden': window.theme.currency === 'GBP' && window.theme.enableIntelligems === true
              },
              (0, _preact.h)(
                'p',
                { className: 'crt-Push_NotificationText' },
                this.notificationMessage
              )
            )
          ),
          (0, _preact.h)(_PushComplimentary2.default, {
            complimentary: this.state.complimentary,
            items: this.state.items,
            subtotal: this.state.subtotal,
            translations: props.translations,
            complimentaryCount: this.complimentaryInCartCount
          }),
          (0, _preact.h)(
            'div',
            {
              className: 'crt-Push_Body',
              style: {
                minHeight: this.isNewItemBeingAdded ? (state.items.length + 1) * 170 + 'px' : ''
              }
            },
            (0, _preact.h)(
              'ul',
              { className: 'crt-Push_Items' },
              this.state.items.map(function (item) {
                return (0, _preact.h)(
                  'li',
                  {
                    className: 'crt-Push_Item',
                    'data-id': item.id,
                    'data-description': item.product_description,
                    'data-handle': item.handle
                  },
                  (0, _preact.h)(_PushItem2.default, {
                    item: item,
                    maxQuantity: state.maxQuantity,
                    removeItem: function removeItem() {
                      return _this3.removeItem(item.key);
                    },
                    updateQuantityOfItem: _this3.updateQuantityOfItem,
                    cartItems: state.items,
                    complimentaryMinPrice: _this3.state.complimentary.min_price,
                    complimentaryMax: _this3.state.complimentary.max,
                    cartSubTotal: state.subtotal
                  })
                );
              })
            ),
            (0, _preact.h)(
              'div',
              { className: 'crt-Push_Loading' },
              (0, _preact.h)(
                'svg',
                {
                  viewBox: '0 0 44 44',
                  xmlns: 'http://www.w3.org/2000/svg',
                  stroke: '#fff'
                },
                (0, _preact.h)(
                  'g',
                  { fill: 'none', fillRule: 'evenodd', strokeWidth: '2' },
                  (0, _preact.h)(
                    'circle',
                    { cx: '22', cy: '22', r: '1' },
                    (0, _preact.h)('animate', {
                      attributeName: 'r',
                      begin: '0s',
                      dur: '1.8s',
                      values: '1; 20',
                      calcMode: 'spline',
                      keyTimes: '0; 1',
                      keySplines: '0.165, 0.84, 0.44, 1',
                      repeatCount: 'indefinite'
                    }),
                    (0, _preact.h)('animate', {
                      attributeName: 'stroke-opacity',
                      begin: '0s',
                      dur: '1.8s',
                      values: '1; 0',
                      calcMode: 'spline',
                      keyTimes: '0; 1',
                      keySplines: '0.3, 0.61, 0.355, 1',
                      repeatCount: 'indefinite'
                    })
                  ),
                  (0, _preact.h)(
                    'circle',
                    { cx: '22', cy: '22', r: '1' },
                    (0, _preact.h)('animate', {
                      attributeName: 'r',
                      begin: '-0.9s',
                      dur: '1.8s',
                      values: '1; 20',
                      calcMode: 'spline',
                      keyTimes: '0; 1',
                      keySplines: '0.165, 0.84, 0.44, 1',
                      repeatCount: 'indefinite'
                    }),
                    (0, _preact.h)('animate', {
                      attributeName: 'stroke-opacity',
                      begin: '-0.9s',
                      dur: '1.8s',
                      values: '1; 0',
                      calcMode: 'spline',
                      keyTimes: '0; 1',
                      keySplines: '0.3, 0.61, 0.355, 1',
                      repeatCount: 'indefinite'
                    })
                  )
                )
              )
            )
          ),
          window.theme.enablePushCartRecommendations && (0, _preact.h)(_PushRecommendations2.default, {
            items: state.items,
            mostRecentlyAddedItemProductId: this.mostRecentlyAddedItemProductId,
            translations: props.translations,
            className: 'crt-Recommended-mobile',
            maxRecommendations: recommendationCount
          }),
          (0, _preact.h)(
            'form',
            {
              className: 'crt-Push_Footer',
              ref: function ref(el) {
                return _this3.refs.footer = el;
              },
              action: props.action
            },
            (0, _preact.h)(
              'div',
              { className: 'crt-Push_Strip' },
              (0, _preact.h)(
                'p',
                { className: 'crt-Push_StripLabel' },
                props.translations.subtotal,
                ':'
              ),
              (0, _preact.h)(
                'p',
                {
                  className: 'crt-Push_StripValue igSubtotal',
                  'data-pushcart-total': state.subtotal
                },
                (0, _functional.formatMoney)(state.subtotal)
              )
            ),
            (0, _preact.h)(
              'div',
              { className: 'crt-Push_BottomBar' },
              (0, _preact.h)(
                'button',
                {
                  type: 'submit',
                  className: 'crt-Push_Submit btn-Primary js-CheckoutButton',
                  name: props.submitTo
                },
                props.translations.checkout
              ),
              (0, _preact.h)(
                'button',
                {
                  type: 'button',
                  'data-module-drawers-close': 'cart',
                  className: 'crt-Push_Continue btn-Secondary'
                },
                props.translations.continue
              )
            )
          )
        )
      );
    }
  }, {
    key: 'promotionEnabled',
    get: function get() {
      var enabled = false;

      if (window.theme.currency === 'EUR') {
        enabled = window.promotionEnabledEur;
      } else if (window.theme.currency === 'AUD') {
        enabled = window.promotionEnabledAud;
      } else if (window.theme.currency === 'CAD') {
        enabled = window.promotionEnabledCad;
      } else {
        enabled = window.promotionEnabled;
      }

      return enabled;
    }
  }, {
    key: 'promotionGiftId',
    get: function get() {
      var giftId = null;

      if (window.theme.currency === 'EUR') {
        giftId = window.promotionGiftIdEur;
      } else if (window.theme.currency === 'AUD') {
        giftId = window.promotionGiftIdAud;
      } else if (window.theme.currency === 'CAD') {
        giftId = window.promotionGiftIdCad;
      } else {
        giftId = window.promotionGiftId;
      }

      return giftId;
    }
  }, {
    key: 'cartHasGift',
    get: function get() {
      var hasGift = false;

      if (this.state.items.filter(function (item) {
        return item.id === window.freeGiftId;
      }).length > 0) {
        hasGift = true;
      }
      return hasGift;
    }
  }, {
    key: 'shouldAddGift',
    get: function get() {
      var doesCartQualify = false;

      for (var i = 0; i < this.state.items.length; i++) {
        var cartProduct = this.state.items[i];

        if (window.giftQualifyingSingleVariants.includes(cartProduct.id)) {
          doesCartQualify = true;
        }
      }

      var countTwo = 0;
      for (var _i = 0; _i < this.state.items.length; _i++) {
        var _cartProduct = this.state.items[_i];

        if (window.giftQualifyingDoubleVariants.includes(_cartProduct.id)) {
          countTwo += _cartProduct.quantity;
        }
        if (countTwo >= 2) {
          doesCartQualify = true;
        }
      }

      return doesCartQualify;
    }
  }, {
    key: 'cartHasPromotionGift',
    get: function get() {
      var hasPromotionGift = false;

      if (this.state.items.filter(function (item) {
        return item.properties.__giftWithPurchase;
      }).length > 0) {
        hasPromotionGift = true;
      }
      return hasPromotionGift;
    }
  }, {
    key: 'shouldAddPromotionGift',
    get: function get() {
      var doesCartQualify = false;
      var alreadyRemovedValue = _jsCookie2.default.get('gwpRemoved-1');

      if (this.state.subtotal >= this.promotionQualifyingTotal && alreadyRemovedValue !== 'true') {
        doesCartQualify = true;
      }

      return doesCartQualify;
    }
  }, {
    key: 'promotionQualifyingTotal',
    get: function get() {
      var total = void 0;

      if (window.theme.currency === 'EUR') {
        total = window.promotionQualifyingTotalEur;
      } else if (window.theme.currency === 'AUD') {
        total = window.promotionQualifyingTotalAud;
      } else if (window.theme.currency === 'CAD') {
        total = window.promotionQualifyingTotalCad;
      } else {
        total = window.promotionQualifyingTotal;
      }

      total = total * 100;

      return total;
    }
  }, {
    key: 'isNewItemBeingAdded',
    get: function get() {
      var _this4 = this;

      return this.state.itemBeingAdded != null && this.state.items.filter(function (item) {
        return item.id === _this4.state.itemBeingAdded;
      }).length === 0;
    }
  }, {
    key: 'refsAreFilled',
    get: function get() {
      return this.refs.topBar != null && this.refs.footer != null && this.refs.notificationBar != null && this.refs.recommendations != null;
    }
  }, {
    key: 'notificationMessage',
    get: function get() {
      var currencyData = this.state.currencyData[window.theme.currency];
      var hasNoThreshold = currencyData && currencyData.threshold === -1;
      var threshold = currencyData && currencyData.threshold || window.theme.freeDeliveryCutoff;
      var isAboveThreshold = hasNoThreshold || this.state.subtotal >= threshold;

      if (hasNoThreshold || isAboveThreshold) {
        return currencyData ? currencyData.messages.aboveThreshold : 'Congratulations, your delivery is eligible for free delivery';
      }

      var money = (0, _functional.formatMoney)(threshold - this.state.subtotal);
      return currencyData ? currencyData.messages.belowThreshold.replace(/{{ ?money ?}}/g, money) : 'Spend another ' + money + ' to get free delivery';
    }
  }, {
    key: 'complimentaryInCartCount',
    get: function get() {
      var complimentaryProductsHandles = this.props.complimentary.products.split(',');
      var isInCart = this.props.complimentary.products ? this.state.items.filter(function (item) {
        return complimentaryProductsHandles.includes(item.handle) && Object.keys(item.properties).includes('_complimentary');
      }).length : 0;

      return isInCart;
    }
  }, {
    key: 'mostRecentlyAddedItemProductId',
    get: function get() {
      if (this.state.items.length === 0) {
        return null;
      }

      // Sort items by key in descending order (assuming higher key = more recent)
      var sortedItems = [].concat((0, _toConsumableArray3.default)(this.state.items)).sort(function (a, b) {
        return b.key - a.key;
      });

      // Return the first item (most recent)
      return sortedItems[0].product_id;
    }
  }, {
    key: 'highestPricedItemProductId',
    get: function get() {
      if (this.state.items.length === 0) {
        return null;
      }

      return this.state.items.reduce(function (highestPricedItem, currentItem) {
        return currentItem.price > highestPricedItem.price ? currentItem : highestPricedItem;
      }).product_id;
    }
  }]);
  return PushCart;
}(_preact.Component);

// eslint-disable-next-line no-unused-vars


exports.default = PushCart;